import { render } from "./plant.vue?vue&type=template&id=223bb9f4&scoped=true"
import script from "./plant.vue?vue&type=script&lang=js"
export * from "./plant.vue?vue&type=script&lang=js"

import "./plant.vue?vue&type=style&index=0&id=223bb9f4&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223bb9f4"]])

export default __exports__